export enum ReservationSizes {
    NONE = 0,
    SM = 18,
    LG = 144,
}
